import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { usePageStore } from "../store/pageStore.js";
import { useBreakpointStore } from "./../store/breakpointStore.js";
function getCurrentBreakpoint(width) {
  const breakpointStore = useBreakpointStore();
  const breakpointsJSON = JSON.stringify(breakpointStore.getAllBreakpoints);
  const breakpointsObject = JSON.parse(breakpointsJSON);
  const breakpoints = breakpointsObject.reverse();
  const breakpoint = breakpoints.find(
    (bp) => bp.minWidth <= width
  );
  return breakpoint;
}
function getApplicableBreakpoints(width) {
  const breakpointStore = useBreakpointStore();
  const breakpoints = breakpointStore.getAllBreakpoints;
  const applicableBreakpoints = breakpoints.filter(
    (breakpoint) => breakpoint.minWidth <= width
  );
  return applicableBreakpoints;
}
function removeEmptyValues(obj) {
  Object.keys(obj).forEach((propName) => {
    const value = obj[propName];
    if (value === null || value.length === 0) {
      delete obj[propName];
    } else if (typeof value === "object") {
      removeEmptyValues(value);
    }
  });
  return obj;
}
function findBreakpointSettings(property) {
  if (property && property.length) {
    const breakpointStore = useBreakpointStore();
    const windowWidth = typeof window !== "undefined" ? window.innerWidth : 380;
    const breakpointWidths = breakpointStore.breakpoints.map((breakpoint) => breakpoint.minWidth).filter((minWidth) => minWidth <= windowWidth).sort((a, b) => {
      return a - b;
    });
    let finalSettings = {};
    breakpointWidths.forEach((breakpointWidth) => {
      const breakpoint = breakpointStore.breakpoints.find(
        (breakpoint2) => breakpoint2.minWidth === breakpointWidth
      );
      if (breakpoint) {
        const propertyBreakpoint = Object.assign(
          {},
          property.find((property2) => {
            if (property2.breakpoint === breakpoint.name)
              return property2;
            return false;
          })
        );
        if (Object.keys(propertyBreakpoint).length > 0) {
          const breakpointSettings = removeEmptyValues(
            cloneDeep(propertyBreakpoint)
          );
          finalSettings = merge(finalSettings, breakpointSettings);
        }
      }
    });
    return finalSettings;
  }
  return null;
}
function sortBreakpoints(settings) {
  if (settings) {
    const breakpointStore = useBreakpointStore();
    const breakpoints = breakpointStore.getAllBreakpoints;
    const templateOrder = breakpoints.map((breakpoint) => {
      return breakpoint.name;
    });
    return settings.slice().sort((a, b) => {
      return templateOrder.indexOf(a.breakpoint) - templateOrder.indexOf(b.breakpoint);
    });
  }
  return [];
}
function breakpointOptions(settings) {
  const { breakpoints } = useBreakpointStore();
  const options = [];
  breakpoints.forEach((breakpoint) => {
    const currentPropertyBreakpoint = settings ? settings.find(
      (propertyBreakpoint) => propertyBreakpoint.breakpoint === breakpoint.name
    ) : null;
    options.push({
      label: currentPropertyBreakpoint ? `${breakpoint.name} (${breakpoint.minWidth}px) | Added` : `${breakpoint.name} (${breakpoint.minWidth}px)`,
      value: breakpoint.name,
      key: breakpoint.name
    });
  });
  return options;
}
function addBreakpoint(element, settings) {
  if (element.id) {
    const pageStore = usePageStore();
    const currentPageElement = pageStore.findElement(element.id)?.element;
    if (currentPageElement && currentPageElement.properties) {
      if (!currentPageElement.properties.settings)
        currentPageElement.properties.settings = [];
      currentPageElement.properties.settings.push(Object.assign({}, settings));
    }
  }
}
function updateBreakpoint(element, settingsIndex, settings) {
  if (element.id) {
    const pageStore = usePageStore();
    const currentPageElement = pageStore.findElement(element.id)?.element;
    if (currentPageElement && currentPageElement.properties && currentPageElement.properties.settings && currentPageElement.properties.settings[settingsIndex]) {
      currentPageElement.properties.settings[settingsIndex] = Object.assign(
        {},
        settings
      );
    }
  }
}
function removeBreakpoint(element, breakpoint) {
  if (element?.properties?.settings) {
    element.properties.settings.splice(
      element.properties.settings.indexOf(breakpoint),
      1
    );
  }
}
function breakPointIsLess(currentBreakpointValue, testBreakpointValue) {
  const bpOptions = breakpointOptions();
  bpOptions.forEach((option) => {
    if (option.value === testBreakpointValue)
      return true;
    if (option.value === currentBreakpointValue)
      return false;
  });
  return false;
}
export {
  findBreakpointSettings,
  sortBreakpoints,
  getCurrentBreakpoint,
  getApplicableBreakpoints,
  breakpointOptions,
  addBreakpoint,
  updateBreakpoint,
  removeBreakpoint,
  breakPointIsLess
};
